import mixpanel from "mixpanel-browser";

import { getAppVariant } from "@/shared/variants/getAppVariant";

import { JwtService } from "../Jwt.service";

type MixpanelUser = {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
};

const isInternalUser = (email: string): boolean => /@cleverfarm\./i.test(email);

const shouldOptOut = (email: string): boolean =>
  isInternalUser(email) && localStorage.getItem("forceMixpanel") !== "true";

const isMixpanelInitialized = (): boolean => {
  try {
    return !!mixpanel.get_distinct_id();
  } catch {
    return false;
  }
};

let initialized = false;

const initializeMixpanel = (user: MixpanelUser): void => {
  if (initialized) return;
  const token = process.env.MIXPANEL_TOKEN;
  if (!token) return;
  if (JwtService.isImpersonatedToken()) return;
  if (shouldOptOut(user.email)) return;

  initialized = true;
  mixpanel.init(token, {
    api_host: "https://api-eu.mixpanel.com",
    autocapture: false,
    track_pageview: false,
    record_sessions_percent: 100,
    record_mask_all_text: false,
  });

  mixpanel.identify(user.id);
  mixpanel.people.set({
    $email: user.email,
    $name: `${user.firstName} ${user.lastName}`,
  });
  mixpanel.register({ variant: getAppVariant() });
};

const setMixpanelFarm = (farmId: string, farmName: string): void => {
  if (!isMixpanelInitialized()) return;
  mixpanel.register({ farm_id: farmId, farm_name: farmName });
};

export { initializeMixpanel, isMixpanelInitialized, setMixpanelFarm };
